(function ($) {
  Drupal.behaviors.astrologyPageFormatterV1 = {
    attach: function (context) {
      var $thisModule = $('.js-astrology-tiles-container', context);
      var containerCols = $thisModule.data('astrology-columns');

      if (containerCols && $(window).width() > 767) {
        $thisModule.css('grid-template-columns', 'repeat(' + containerCols + ', 1fr)');
      }
    }
  };
})(jQuery);
